<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6qhXx1/images/backcover.jpg?1733067611566" alt="This image is the cover for the book Master of Space and Time"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Master of Space and Time
      </h1>
      <p class="bookDescription body article font2">
        <p>The real world is unbearable to madcap inventor Harry Gerber, so he uses his genius to twist the laws of science and create his own tailor-made universe. <i>Master of Space and Time</i> combines high physics and high jinks, blurring the line between science and magic. From a voyage to a mirror-image world where sluglike parasites make slaves of humanity, to trees and bushes that grow fries and pork chops, to a rain of fish, author Rudy Rucker -- two-time winner of the Philip K. Dick Award -- takes readers on the ultimate joyride. But once the gluons at the core of Harry's creation run out  . . .  disaster looms for Harry and his friends.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rudy Rucker
      </h2>
      
      <p class="authorDescription body article"><B>Rudy Rucker</B> is a two-time winner of the Philip K. Dick award and a professor of computer science at San Jose State University. <I>White Light</I>, a novel; <I>Gnarl!</I>, a collection of his short fiction; and <I>Seek!</I>, a collection of essays, are also published by Four Walls Eight Windows.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thunder’s Mouth Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4cbe0dd5